import React, { useState, useEffect, useContext, createContext, useMemo } from 'react'
import useData from '../hooks/useData'
import { isProviderLink } from '../modules/provider'
import { useApi } from '../modules/fetch'
import URI from 'urijs'
import { withRouter } from 'react-router-dom'
import { appStateContext } from '../App'

const uuidv4 = require('uuid/v4')
export const ResourcesContext = createContext()

let params = {}
function getSelectionText() {
    var text = ''
    if (window.getSelection) {
        text = window.getSelection().toString()
    } else if (document.selection && document.selection.type !== 'Control') {
        text = document.selection.createRange().text
    }
    return text
}
const logClick = (e) => {
    if (e.target && e.target.dataset.pfHref) {
        console.log(e.target.dataset.pfHref)
    }
}
const scroll = () => {
    const rb = document.querySelector('#resource-bucket')
    rb && (rb.scrollTop = rb.scrollHeight)
}
const getProductIdObject = (url) => {
    // amazon
    const query = URI.parseQuery(url)
    let ASIN = query['ASIN']
    const creativeASIN = query['creativeASIN']
    const creative = query['creative']
    if (!ASIN && !creativeASIN) {
        if (url.indexOf('/dp/')) {
            ASIN = url.substring(url.indexOf('/dp/') + 4)
            ASIN = ASIN.substring(0, ASIN.indexOf('/'))
        }
    }
    return { ASIN, creativeASIN, creative }
}

const ArticleResources = (props) => {
    // const article_id = props.article_id || (props.match && props.match.params && props.match.params.article_id) || false
    const appState = useContext(appStateContext)
    const article_id = appState.state.resource_article_id
    const [resourceArray, setResourceArray] = useState([])
    const [url, setUrl] = useState(props.url || null)
    const [displayUrl, setDisplayUrl] = useState(props.displayUrl || null)
    const articleData = useData(
        {
            url: 'article/' + article_id,
            transform: (data) => ({
                ...data,
                resources: (data.resources && JSON.parse(data.resources)) || null,
            }),
        },
        [!!article_id && article_id !== 'undefined']
    )
    // console.log({articleData}, resourceArray)
    // const siteData = useData({ url: 'site/' + (articleData.data && articleData.data.site_id) }, [articleData.isReady, (articleData.data && articleData.data.site_id)])
    const siteArray = useData('site')
    const siteData = {
        ...siteArray,
        data: (siteArray.data && articleData.data && siteArray.data.find((s) => s.id == articleData.data.site_id)) || undefined,
    }

    const resourceApi = useApi()
    const [tick, setTick] = useState(0)
    // console.log({CrawledPageDetails})
    const addUIToText = (_params) => {
        const { origin, target_article, originalUrl, displayUrl } = _params || {}
        // console.log(target_article, originalUrl, displayUrl)
        ;[...document.querySelectorAll('.pf-ui-a')].map((n) => n.parentNode.removeChild(n))
        ;[...document.querySelectorAll('.competitor-page-html a')].map((a) => {
            if (a.dataset.pfHref && isProviderLink(a.dataset.pfHref)) {
                a.dataset['provider'] = true
            }
        })
        // console.log(document.querySelectorAll('.competitor-page-html a'))
        ;[...document.querySelectorAll('.competitor-page-html a[data-pf-href]:not([data-provider])')].map((a) => {
            if (a.dataset.pfHref.substring(0, 4) === 'http') {
                const aNode = document.createElement('a')
                aNode.href = 'https://dereferer.me/?' + escape(a.dataset.pfHref)
                aNode.target = '_blank'
                aNode.classList.add('pf-ui-a')
                const iconNode = document.createElement('i')
                iconNode.classList.add('fa')
                iconNode.classList.add('fa-external-link-alt')
                aNode.classList.add('ml-1')
                aNode.appendChild(iconNode)
                a.parentNode.insertBefore(aNode, a.nextSibling)
            }
        })
        ;[...document.querySelectorAll('.competitor-page-html a[data-provider]')].map((a) => {
            // console.log(parseUrl(a.dataset.pfHref))
            const href = URI(a.dataset.pfHref)
            href.removeSearch('SubscriptionId')
            href.removeSearch('tag')
            const providerProductId = getProductIdObject(a.dataset.pfHref)
            console.log({ providerProductId })
            const sanitizedUrl = href.toString()
            providerProductId.sanitizedUrl = sanitizedUrl
            // href.addSearch("SubscriptionId", "--SubscriptionId--")
            // console.log(a.dataset.pfHref, {providerProductId})
            const parentNode = document.createElement('span')
            const aNode = document.createElement('a')
            const iconNode = document.createElement('i')
            const textNode = document.createElement('span')
            const externalANode = document.createElement('a')
            parentNode.classList.add('pf-ui-a')
            if (target_article) {
                aNode.classList.add('btn')
                aNode.classList.add('btn-xs')
                aNode.classList.add('btn-amazon')
                aNode.classList.add('ml-1')
                aNode.dataset.providerProduct = true
                aNode.dataset.providerProductId = JSON.stringify(providerProductId)
                aNode.dataset.pfDisplayUrl = displayUrl
                aNode.dataset.pfOriginalUrl = originalUrl
                aNode.dataset.pfOrigin = origin
                textNode.dataset.providerProduct = true
                textNode.dataset.providerProductId = JSON.stringify(providerProductId)
                textNode.dataset.pfDisplayUrl = displayUrl
                textNode.dataset.pfOriginalUrl = originalUrl
                textNode.dataset.pfOrigin = origin
                textNode.dataset.pfHref = a.dataset.pfHref
            }
            externalANode.href = 'https://dereferer.me/?' + escape(a.dataset.pfHref)
            externalANode.target = '_blank'
            externalANode.classList.add('btn')
            externalANode.classList.add('btn-xs')
            externalANode.classList.add('btn-amazon')
            externalANode.classList.add('ml-1')
            iconNode.classList.add('fab')
            iconNode.classList.add('fa-amazon')
            textNode.innerText = '»'
            externalANode.classList.add('ml-1')
            externalANode.appendChild(iconNode)
            parentNode.appendChild(externalANode)
            if (target_article) {
                aNode.appendChild(textNode)
                parentNode.appendChild(aNode)
            }
            // aNode.onclick = () => addProduct({ providerProductId, originalUrl: a.dataset.pfHref })
            parentNode.onclick = AddProductEffect
            a.parentNode.insertBefore(parentNode, a.nextSibling)
        })
        // window.addEventListener('click', logClick)
        // window.addEventListener('click', AddProductEffect)
        return () => {
            // window.removeEventListener('click', logClick)
            // window.removeEventListener('click', AddProductEffect)
        }
    }
    const AddProductEffect = (e) => {
        console.log('click', e)
        if (e.target && e.target.dataset.providerProductId) {
            params = {
                providerProductId: JSON.parse(e.target.dataset.providerProductId),
                originalUrl: e.target.dataset.pfOriginalUrl || e.target.dataset.pfHref,
                displayUrl: e.target.dataset.pfDisplayUrl || displayUrl,
                origin: e.target.dataset.pfOrigin,
            }
            console.log({ params })
            setTick(Math.random())
        }
    }

    useEffect(() => {
        const resources = (articleData.isReady && articleData.data && articleData.data.resources) || []
        setResourceArray(resources)
    }, [articleData.isReady, articleData.data && articleData.data.resources, article_id])

    const addSelectedText = ({ displayUrl_, originalUrl_, origin_ }) => {
        console.log({ displayUrl_ })
        const resources = [
            ...resourceArray,
            {
                type: 'text',
                id: uuidv4(),
                displayUrl: displayUrl_ || displayUrl,
                originalUrl: originalUrl_ || url,
                origin: origin_ || props.origin,
                url,
                text: getSelectionText(),
            },
        ]
        resourceApi.put('article/' + article_id, {
            resources: JSON.stringify(resources),
        })
        setResourceArray(resources)
        scroll()
    }
    const addProduct = ({ providerProductId, originalUrl_, displayUrl_, origin_, image_url, locale, tracking_id }) => {
        console.log({ providerProductId }, { originalUrl_ })
        const resources = [
            ...resourceArray,
            {
                type: 'product',
                provider: 'amazon',
                locale,
                tracking_id,
                id: uuidv4(),
                displayUrl: displayUrl_ || params.displayUrl || displayUrl,
                originalUrl: params.originalUrl,
                origin: origin_ || params.origin,
                url: originalUrl_ || params.originalUrl,
                text: originalUrl_,
                image_url,
                providerProductId,
            },
        ]
        resourceApi.put('article/' + article_id, {
            resources: JSON.stringify(resources),
        })
        setResourceArray(resources)
    }
    // add product hook
    useEffect(() => {
        if (tick !== 0) {
            console.log('ticked', tick, resourceArray, params)
            addProduct(params)
        }
    }, [tick])

    // const deleteResource = id => {
    //     const resources = [...resourceArray.filter(r => r.id !== id)]
    //     setResourceArray(resources)
    //     resourceApi.put('article/' + article_id, {
    //         resources: JSON.stringify(resources)
    //     })
    // }

    const updateResources = (resources) => {
        setResourceArray(resources)
        console.log('updateResources', { resources })
        resourceApi.put('article/' + article_id, {
            resources: JSON.stringify(resources),
        })
    }
    // console.log({ articleData })
    const contextValue = useMemo(
        () => ({
            article_id,
            updateResources,
            resources: resourceArray,
            site: siteData.isReady && siteData.data,
            addProduct,
            addUIToText,
            setUrl,
            setDisplayUrl,
            resourceApi,
            addSelectedText,
        }),
        [article_id, siteData.data, resourceArray, resourceApi, url, displayUrl]
    )
    return <ResourcesContext.Provider value={contextValue}>{props.children}</ResourcesContext.Provider>
}

export default withRouter(ArticleResources)
